<script>
import Layout from '@layouts/main'

import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

import empresa_sistema from '@/src/services/empresa_sistema'
import vinculoPlano from '@/src/services/vinculo-plano'
import formVincularPlano from '@/src/components/form-vincular-plano.vue'

/**
 * Empresa Component
 */
export default {
  components: {
    Layout,
    Loading,
    formVincularPlano,
  },
  data() {
    return {
      empresaEdit: {},
      empresa_sistema: [],
      empresaForm: true,
      idUserDelete: '',
      modal: false,
      isLoading: true,
      filter: '',
      artPrimaria: '',
      nReceitasArt: '',
      artImpressao: '',
      empresaFields: [
        {
          key: 'data_inicio',
          label: 'Data Início',
        },
        {
          key: 'tipo_plano',
          label: 'Tipo de Plano',
        },
        {
          key: 'valor',
          label: 'Valor',
        },
        {
          key: 'empresa_sistema.cnpj',
          label: 'CNPJ',
        },
        {
          key: 'empresa_sistema.nome',
          label: 'Nome',
        },

        { key: 'actions', label: '' },
      ],
      currentPage: 1,
      perPage: 20,
    }
  },
  computed: {
    rows() {
      return empresa_sistema.length
    },
  },
  watch: {
    empresaForm() {
      if (this.empresaForm) {
        this.listando()
      }
    },
  },
  mounted() {
    this.listando()
  },
  methods: {
    listando() {
      this.isLoading = true
      const token = this.$store.state.auth.currentUser.token
      vinculoPlano
        .listar(token)
        .then((resposta) => {
          this.empresa_sistema = resposta.data
          this.isLoading = false
        })
        .catch((error) => {
          console.log(error)
          this.empresa_sistema = []
          this.isLoading = false
        })
    },
    listandoByFilter() {
      if (this.filter && this.filter.trim()) {
        const token = this.$store.state.auth.currentUser.token
        this.isLoading = true
        vinculoPlano
          .findByName(token, this.filter)
          .then((resposta) => {
            this.empresa_sistema = resposta.data
            this.isLoading = false
          })
          .catch((error) => {
            console.log(error)
            this.empresa_sistema = []
            this.isLoading = false
          })
      } else {
        this.listando()
      }
    },
    abrirForm() {
      if (this.empresaForm === true) {
        this.empresaForm = false
      } else {
        this.empresaForm = true
        this.empresaEdit = {}
      }
    },
    editRegister(empresa) {
      this.empresaEdit = empresa
      this.empresaForm = false
    },
    modalDelete(item) {
      this.modal = true
      this.idUserDelete = item
    },
    handleDelete() {
      const token = this.$store.state.auth.currentUser.token
      vinculoPlano
        .deleteVinculo(token, this.idUserDelete)
        .then((reposta) => {
          this.listando()
          this.$bvToast.toast('Empresa removida com sucesso!', {
            variant: 'success',
            solid: true,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
        })
        .catch((err) => {
          console.log(err)
          this.isLoading = this.loading(this.isLoading)
          this.$bvToast.toast(
            'Ocorreu um erro ao deletar, verifique se o item está sendo utilizado em outro lugar.',
            {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            }
          )
        })
      this.idUserDelete = null
      this.modal = false
    },
  },
}
</script>
<template>
  <Layout>
    <div class="bloco">
      <div>
        <div class="row">
          <div class="col-md-11">
            <div class="titulo">Vincular Empresas</div>
            <div class="subTitulo"
              >Faça o vinculo da empresa com o plano contratado.</div
            >
          </div>
          <div class="col-md-1">
            <div class="float-right">
              <button class="btn btn-primary" @click="abrirForm">
                <span v-if="empresaForm">Novo</span>
                <span v-else>Ver todos</span>
              </button>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="borda"></div>
          </div>
        </div>
        <div v-if="empresaForm" class="row">
          <div class="col-md-4">
            <b-form-group id="input-group-1" label="Nome" label-for="filter">
              <b-form-input
                id="filter"
                v-model="filter"
                type="text"
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="col-md-2 mt-4 pt-1">
            <button class="btn btn-primary" @click="listandoByFilter"
              >Pesquisar</button
            >
          </div>
        </div>
      </div>
      <div>
        <div v-if="empresaForm">
          <b-table
            striped
            hover
            responsive="sm"
            borderless
            bordered
            outlined
            small
            :items="empresa_sistema"
            :fields="empresaFields"
            :current-page="currentPage"
            :per-page="perPage"
          >
            <template v-slot:cell(actions)="row">
              <div class="btn-group mb-2">
                <b-dropdown
                  v-b-tooltip.hover
                  size="md"
                  variant="link"
                  toggle-class="text-decoration-none"
                  no-caret
                  title="Edite ou Delete o Plano"
                >
                  <template v-slot:button-content>
                    <i class="uil uil-ellipsis-v"></i>
                  </template>
                  <b-dropdown-item @click="editRegister(row.item)"
                    >Editar</b-dropdown-item
                  >
                  <b-dropdown-item
                    @click="modalDelete(row.item.id_vinculo_plano)"
                    >Excluir</b-dropdown-item
                  >
                </b-dropdown>
              </div>
            </template>
          </b-table>
          <b-pagination
            v-model="currentPage"
            size="md"
            :total-rows="rows"
            :per-page="perPage"
          ></b-pagination>
        </div>
        <div v-else>
          <formVincularPlano :vinculo="empresaEdit" />
        </div>
      </div>

      <div class="borda"></div>
    </div>
    <b-modal v-model="modal" title="Aviso" title-class="font-18">
      <p>Tem certeza que deseja excluir este registro?</p>
      <template v-slot:modal-footer>
        <b-button variant="light" @click="modal = false">Não</b-button>
        <b-button variant="danger" @click="handleDelete">Sim</b-button>
      </template>
    </b-modal>

    <loading
      :active.sync="isLoading"
      color="#008e75"
      :can-cancel="true"
    ></loading>
  </Layout>
</template>
<style lang="scss">
.bloco {
  margin-top: 30px;
  background-color: #fff;
  padding: 40px;
  border-radius: 0.25rem;

  .titulo {
    font-size: 25px;
    color: #008e75;
    margin-bottom: 10px;
    font-weight: bold;
  }

  .subtitulo {
    margin-bottom: 10px;
  }

  .borda {
    margin-top: 15px;
    margin-bottom: 15px;
    border-bottom: solid 1px #edeff4;
  }

  .formulario {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .btn-webreceita {
    margin-top: 30px;
    margin-bottom: 10px;
    background-color: #008e75;
    padding: 5px 30px;

    &.botaoTopo {
      float: right;
    }
  }

  .filterButton {
    background-color: #008e74c7;
    padding: 0 20px;
  }

  .cadastra {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
